<template lang="pug" src="./order-table.pug"></template>
<style lang="scss" scoped>
.order-id {
    cursor: pointer;

    &:hover {
        color: lightskyblue;
    }
}
</style>

<script>
import Vue from 'vue';

import infoOrder from '@/views/pages/ReceiveOrders/info-order';
import { mapState, mapGetters } from 'vuex';
import copyToClipboard  from '@/utils/copy';

export default {
    components: {
        'v-info-order': infoOrder
    },
    props: {
        items: {
            type: Array,
            default: () => []
        },
        loading: {
            type: Boolean,
            default: false
        },
        showId: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        ...mapGetters(['userBrandId']),
        ...mapState({
            orderHistories: state => state.orders.orderHistories
        }),
        headers() {
            const properties = [
                'createdAt', 'gettingOrderTime', 'status', 'statusesHistory',
                'address', 'comments', 'additionAddresses', 'car',
                'arrivalTime', 'routeLength', 'stayTime', 'options', 'operator',
                'calculatedPrice', 'price'
            ];

            if (this.showId) {
                properties.unshift('id');
            }

            if (!this.userBrandId) {
                properties.splice(properties.length - 1, 0, 'brandId');
            }

            return properties.filter(it => !!it).map(it => ({
                text: this.$vuetify.lang.t(`$vuetify.pages.History.table.${it}`),
                value: it,
                sortable: false,
                align: 'center'
            }));
        }
    },
    created() {
        (this.items || []).forEach(order => {
            if (order.stayTime) {
                const date = new Date(null);

                date.setSeconds(order.stayTime);
                order.stayTime = date.toISOString().substr(14, 5);
            }

            order.addresses = order.unorderedAddresses
                .sortBy('sortOrder')
                .map('place')
                .map(it => Vue.filter('extendAddress')(it));
        });
    },
    methods: {
        copyToClipboard
    }
};
</script>
